
import React,{useState,useEffect} from "react";

import { ORG_NATURE_OF_CALLS_LIST,ORG_IMPORT_MASTER_LIST} from '../../../../../ApiServices/BaseURL';
import { getData, postData } from "../../../../../ApiServices/ApiService";
import { useTheme } from "../../../../../GlobalContext/GlobalContext";
import { logFrontendException } from "../../../../../Utils/Exception";

const OtherSettingsConteoller = ()=>{
    const[loading,setLoading]= useState(false);
  const[error,setError] = useState('');
  const[callsList,setCallsList] = useState([]);
  const { setIsLoginPopup } = useTheme();
  const pageName ="OtherSettings"
  const storedUserId = JSON.parse(localStorage.getItem("_userInfo_"))?.emp_id;
    useEffect(()=>{
    fetchNatureOfCallsList();
    fetchImportMasterList();
},[])

    const fetchNatureOfCallsList =async ()=>{
        try {
          setLoading(true);
          setCallsList([]);
            setError('');
            // setTeamInfo({});
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
        
            // Make the API call
            const response = await getData(`${ORG_NATURE_OF_CALLS_LIST}?emp_id_auth=${storedUserInfo?.emp_id}`);
            const responseData = await response.json();
        
            // Check for success (200) and internal status code
            if (response?.status === 200) {
              if (responseData?.statusCode === 200) {
                if (responseData?.message.toLowerCase() === 'success') {
                  if (responseData?.dataJ?.length > 0) {
                    const records = responseData?.dataJ || [];
                    setCallsList(records)
                  } else {
                    setError(responseData?.info || 'Data Not Found');
                    logFrontendException(storedUserId, pageName, "CallsList", responseData?.info || '');
                  }
                } else {
                  setError(responseData?.info || 'Failed to fetch nature of calls. Please try again.');
                  logFrontendException(storedUserId, pageName, "CallsList", responseData?.info || '');
                }
              } else {
                setError(responseData?.info || 'Failed to fetch nature of calls.');
                logFrontendException(storedUserId, pageName, "CallsList", responseData?.info || '');
              }
            } 
            // Token-related errors: 400, 401, 403
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
              if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
                setError('Unauthorized access. Your session may have expired. Please log in again.');
                logFrontendException(storedUserId, pageName, "CallsList", response || '');
                // Optionally, redirect to the login page or refresh the token
                // Example: redirectToLogin();
              } else {
                setError(responseData?.info || 'Bad request. Please check the request parameters.');
                logFrontendException(storedUserId, pageName, "CallsList", response || '');
              }
            } 
            // Internal Server Error: 500
            else if (response?.status === 500) {
              setError(responseData?.info || 'Internal Server Error. Please try again later.');
              logFrontendException(storedUserId, pageName, "CallsList", response || '');
            } 
            // Unexpected or network-related errors
            else {
              setError('Unexpected error occurred. Please try again later.');
              logFrontendException(storedUserId, pageName, "CallsList", response || '');
            }
          } catch (error) {
            // Handle various error scenarios
            if (error.response) {
              // Server responded with a status outside the 2xx range
              setError(`Error: ${error.response.status}. ${error.response.data?.message || 'Failed to fetch nature of calls. Please try again.'}`);
              logFrontendException(storedUserId, pageName, "CallsList", error || '');
            } else if (error.request) {
              // Request was made but no response was received
              setError('No response received from the server. Please check your network connection and try again.');
              logFrontendException(storedUserId, pageName, "CallsList", error || '');
            } else {
              // An error occurred in setting up the request
              setError(`Failed to fetch nature of calls. Please check your network connection and try again.`);
              logFrontendException(storedUserId, pageName, "CallsList", error || '');
            }
          } finally {
            setLoading(false);
          }
      }

      const[importMasterListLoading,setImportMasterListLoading]= useState(false);
  const[importMasterListError,setImportMasterListError] = useState('');
  const[importMasterList,setImportMasterList] = useState([]);
      const fetchImportMasterList =async ()=>{
        try {
          setImportMasterListLoading(true);
          setImportMasterList([]);
          setImportMasterListError('');
            // setTeamInfo({});
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
            const payload={
              emp_id_auth: storedUserInfo?.emp_id
            }
        
            // Make the API call
            const response = await postData(ORG_IMPORT_MASTER_LIST,payload );
            const responseData = await response.json();
        
            // Check for success (200) and internal status code
            if (response?.status === 200) {
              if (responseData?.statusCode === 200) {
                if (responseData?.message.toLowerCase() === 'success') {
                  if (responseData?.dataJ?.length > 0) {
                    const records = responseData?.dataJ || [];
                    setImportMasterList(records)
                  } else {
                    setImportMasterListError(responseData?.info || 'Data Not Found');
                    logFrontendException(storedUserId, pageName, "masterslist", responseData?.info || '');
                  }
                } else {
                  setImportMasterListError(responseData?.info || 'Failed to fetch nature of calls. Please try again.');
                  logFrontendException(storedUserId, pageName, "masterslist", responseData?.info || '');
                }
              } else {
                setImportMasterListError(responseData?.info || 'Failed to fetch nature of calls.');
                logFrontendException(storedUserId, pageName, "masterslist", responseData?.info || '');
              }
            } 
            // Token-related errors: 400, 401, 403
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
              if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
                setImportMasterListError('Unauthorized access. Your session may have expired. Please log in again.');
                logFrontendException(storedUserId, pageName, "masterslist", response || '');
                // Optionally, redirect to the login page or refresh the token
                // Example: redirectToLogin();
              } else {
                setImportMasterListError(responseData?.info || 'Bad request. Please check the request parameters.');
                logFrontendException(storedUserId, pageName, "masterslist", response || '');
              }
              setIsLoginPopup(true)
            } 
            // Internal Server Error: 500
            else if (response?.status === 500) {
              setImportMasterListError(responseData?.info || 'Internal Server Error. Please try again later.');
              logFrontendException(storedUserId, pageName, "masterslist", response || '');
            } 
            // Unexpected or network-related errors
            else {
              setImportMasterListError('Unexpected error occurred. Please try again later.');
              logFrontendException(storedUserId, pageName, "masterslist", response || '');
            }
          } catch (error) {
            // Handle various error scenarios
            if (error.response) {
              // Server responded with a status outside the 2xx range
              setImportMasterListError(`Error: ${error.response.status}. ${error.response.data?.message || 'Failed to fetch nature of calls. Please try again.'}`);
              logFrontendException(storedUserId, pageName, "masterslist", error || '');
            } else if (error.request) {
              // Request was made but no response was received
              setImportMasterListError('No response received from the server. Please check your network connection and try again.');
              logFrontendException(storedUserId, pageName, "masterslist", error || '');
            } else {
              // An error occurred in setting up the request
              setImportMasterListError(`Failed to fetch nature of calls. Please check your network connection and try again.`);
              logFrontendException(storedUserId, pageName, "masterslist", error || '');
            }
          } finally {
            setImportMasterListLoading(false);
          }
      }

      return{
        loading,
    error,
    callsList,
    fetchNatureOfCallsList,
    importMasterList,
    importMasterListError,
    importMasterListLoading,
    fetchImportMasterList
      }
}

export default OtherSettingsConteoller